import './src/auth/recovery';
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN || 'https://1f027d4ccc584709bcd0f495f5991633@o1157603.ingest.sentry.io/6240115',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,
  // AuthMS CORS permits the V2 headers; do not inject tracing headers into auth calls.
  integrations: [
    new Sentry.BrowserTracing({
      shouldCreateSpanForRequest: (url) => !url.includes('/auth/')
    })
  ],
  beforeBreadcrumb(breadcrumb) {
    return /auth|password|token|otp/i.test(JSON.stringify(breadcrumb)) ? null : breadcrumb;
  },
  beforeSend(event) {
    const sanitized = { ...event };
    if (event.request) {
      const { data, headers, ...request } = event.request;
      const [url] = (request.url || '').split('#');
      sanitized.request = { ...request, url };
    }
    delete sanitized.extra;
    sanitized.breadcrumbs = (event.breadcrumbs || []).filter(
      (item) => !/auth|password|token|otp/i.test(JSON.stringify(item))
    );
    return sanitized;
  }
});
